import ReactDOM from 'react-dom';
import App from 'App';
import { setApiKeyAzureAxios } from 'utils/functions/axiosHeaderSetters';

setApiKeyAzureAxios('03008c32-a70a-4328-bd63-21c5b2aae048');

// application rendering 
ReactDOM.render(
    <App />,
    document.getElementById('root')
);
